import * as PIXI from 'pixi.js';
import { LayoutContainer } from '@pixi/layout/components'; // eslint-disable-line
import { DropShadowFilter} from 'pixi-filters';
import { APP_WIDTH, APP_HEIGHT, CARD_WIDTH, CARD_HEIGHT } from '../utils/commonUtils';

import CardContainer from './cardContainer';
import ActionButtonsContainer from './actionButtonsContainer';

export default class SelectFromTrashContainer extends PIXI.Container {
    constructor() {
        super();
        this.cards = [];

        const backgroundGraphics = new PIXI.Graphics();
        backgroundGraphics.label = 'backgroundGraphics';
        backgroundGraphics.rect(-APP_WIDTH / 2 + 50, -APP_HEIGHT / 2 + 300, APP_WIDTH - 100, APP_HEIGHT - 600);
        backgroundGraphics.fill({ color: '#000000', alpha: 0.9 });
        backgroundGraphics.stroke({ color: '#293a5d', width: 12 });
        this.addChild(backgroundGraphics);

        const titleColorGradient = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0.5, y: 0 },
            end: { x: 0.5, y: 1 },
            colorStops: [
              { offset: 0, color: '#ffe17d' },
              { offset: 0.5, color: '#ffe17d' },
              { offset: 1, color: '#faf2d8' },
            ],
        });
        
        const titleText = new PIXI.Text({
            text: 'Select from Trash',
            style: {
                fontFamily: 'Caladea',
                fontSize: 82,
                fontWeight: '700',
                fill: titleColorGradient,
                stroke: { color: ' #422400', width: 3 },
            },
        });
        titleText.anchor.set(0.5, 1);
        titleText.label = 'titleText';
        titleText.x = 0;
        titleText.y = -700;
        this.addChild(titleText);

        const lineGradient = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
              { offset: 0, color: 'rgba(255, 255, 255, 0)' },
              { offset: 0.25, color: 'rgba(255, 255, 255, 1)' },
              { offset: 0.75, color: 'rgba(255, 255, 255, 1)' },
              { offset: 1, color: 'rgba(255, 255, 255, 0)' },
            ],
          });

        const lineGraphics1 = new PIXI.Graphics();
        lineGraphics1.label = 'lineGraphics1';
        lineGraphics1.x = 0;
        lineGraphics1.y = -630;
        lineGraphics1.rect(-APP_WIDTH / 2 + 50, -2, APP_WIDTH - 100, 4);
        lineGraphics1.fill(lineGradient);
        this.addChild(lineGraphics1);

        this.CardListContainer = new LayoutContainer({
            layout: {
                width: APP_WIDTH - 100,
                height: 1190,
                flexDirection: 'row',
                alignContent: 'flex-start',
                overflow: 'scroll',
                gap: 28,
                padding: 60,
                flexWrap: 'wrap',
            }
        });
        this.CardListContainer.label = 'CardListContainer';
        this.CardListContainer.x = -APP_WIDTH / 2 + 50;
        this.CardListContainer.y = -628;
        this.addChild(this.CardListContainer);

        const footerGradient = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0.5, y: 0 },
            end: { x: 0.5, y: 1 },
            colorStops: [
              { offset: 0, color: '#1e2a44' },
              { offset: 0.5, color: '#2c3e64' },
              { offset: 1, color: '#1e2a44' },
            ],
        });

        const footerGraphics = new PIXI.Graphics();
        footerGraphics.label = 'footerGraphics';
        footerGraphics.rect(-APP_WIDTH / 2 + 50, 565, APP_WIDTH - 100, 300);
        footerGraphics.fill(footerGradient);
        footerGraphics.stroke({ color: '#293a5d', width: 12 });
        footerGraphics.filters = [new DropShadowFilter({
            color: '#000000',
            alpha: 1,
            blur: 5,
            offset: { x: 0, y: -30 },
            pixelSize: { x: 1, y: 1 },
            quality: 10,
        })];
        this.addChild(footerGraphics);

        this.actionButtonsContainer = new ActionButtonsContainer();
        this.actionButtonsContainer.hideBackground();
        this.actionButtonsContainer.label = 'actionButtonsContainer';
        this.actionButtonsContainer.x = 0;
        this.actionButtonsContainer.y = 710;
        this.addChild(this.actionButtonsContainer);
    }

    destroyCards() {
        this.CardListContainer.removeChildren();
    }

    rebuildCards(cards) {
        this.destroyCards();

        cards.forEach((card) => {
            const cardContainer = new CardContainer(card);
            cardContainer.getChildByLabel('cardVisualsContainer').pivot.set(-CARD_WIDTH / 2, -CARD_HEIGHT);
            cardContainer.showRested = false;
            cardContainer.hidePowerText();
            cardContainer.layout = { width: CARD_WIDTH, height: CARD_HEIGHT };
            cardContainer.enableEventPropagation();
            
            this.CardListContainer.addChild(cardContainer);
        });
    }

    update(gameState) {
        const cardsChanged = this.cards.length !== gameState.player.trash.length || this.cards.some((card, i) => card.instanceId !== gameState.player.trash[i].instanceId);
        if (cardsChanged) {
            this.cards = gameState.player.trash;
            this.rebuildCards(this.cards);
        }

        const selectableCards = gameState.clientGameState.selectableCards;
        const selectedCard = gameState.clientGameState.selectedCard;

        let canConfirm = false;
        this.CardListContainer.overflowContainer.children.forEach((cardContainer) => {
            if (selectableCards.includes(cardContainer.cardInstance.instanceId)) {
                if (selectedCard === cardContainer.cardInstance.instanceId) {
                    cardContainer.setHighlightSelected();
                    canConfirm = true;
                } else {
                    cardContainer.unhighlightCard();
                }
                
                cardContainer.tint = 0xFFFFFF;
            } else {
                cardContainer.unhighlightCard();
                cardContainer.tint = 0x777777;
            }
        });

        if (canConfirm) {
            this.actionButtonsContainer.update({ clientGameState: { availableActions: ['NO_SELECTION', 'CONFIRM'] } });
        } else {
            this.actionButtonsContainer.update({ clientGameState: { availableActions: ['NO_SELECTION', { type: 'CONFIRM', disabled: true }] } });
        }
    }

    resize(width, height) {
        const backgroundGraphics = this.getChildByLabel('backgroundGraphics');
        backgroundGraphics.clear();
        backgroundGraphics.rect(-width / 2 + 50, -height / 2 + 300, width - 100, height - 600);
        backgroundGraphics.fill({ color: '#000000', alpha: 0.9 });
        backgroundGraphics.stroke({ color: '#293a5d', width: 12 });
    }
}